import { memo } from "react";

const Illustration = function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="26"
      fill="none"
      viewBox="0 0 49 26"
    >
      <g clipPath="url(#clip0_5005_8689)">
        <path
          fill="#fff"
          d="M35.732 0H13.294C6.282 0 .544 5.764.544 12.808c0 7.045 5.738 12.809 12.75 12.809h22.438c7.012 0 12.749-5.764 12.749-12.809C48.48 5.764 42.744 0 35.73 0z"
        ></path>
        <path
          fill="#3C4043"
          d="M35.732 1.037c1.574 0 3.104.314 4.545.93a11.815 11.815 0 013.729 2.529 11.806 11.806 0 012.518 3.746c.612 1.447.924 2.984.924 4.566 0 1.582-.312 3.12-.924 4.566a11.877 11.877 0 01-2.518 3.747 11.744 11.744 0 01-3.729 2.53 11.52 11.52 0 01-4.545.928H13.294a11.52 11.52 0 01-4.545-.928 11.816 11.816 0 01-3.73-2.53 11.804 11.804 0 01-2.517-3.747 11.666 11.666 0 01-.925-4.566c0-1.582.313-3.119.925-4.566A11.877 11.877 0 015.02 4.496a11.744 11.744 0 013.729-2.53 11.52 11.52 0 014.545-.929h22.438zm0-1.037H13.294C6.282 0 .544 5.764.544 12.808c0 7.045 5.738 12.809 12.75 12.809h22.438c7.012 0 12.749-5.764 12.749-12.809C48.48 5.764 42.744 0 35.73 0z"
        ></path>
        <path
          fill="#3C4043"
          d="M23.404 13.718v3.874H22.18V8.024h3.244c.823 0 1.524.276 2.098.827.586.55.88 1.223.88 2.017 0 .813-.294 1.486-.88 2.03-.568.544-1.269.813-2.098.813h-2.02v.007zm0-4.515v3.336h2.046c.484 0 .892-.166 1.211-.493.325-.326.49-.723.49-1.172 0-.442-.165-.832-.49-1.159-.319-.34-.72-.506-1.211-.506h-2.046v-.006zM31.601 10.83c.905 0 1.62.243 2.142.73.523.486.784 1.152.784 1.998v4.034H33.36v-.91h-.05c-.504.75-1.18 1.122-2.021 1.122-.72 0-1.32-.212-1.804-.64a2.049 2.049 0 01-.727-1.602c0-.679.255-1.217.765-1.614.51-.403 1.192-.602 2.04-.602.726 0 1.326.135 1.791.404v-.282c0-.43-.166-.788-.504-1.089a1.723 1.723 0 00-1.185-.448c-.682 0-1.224.288-1.62.87l-1.077-.678c.593-.864 1.473-1.294 2.633-1.294zm-1.58 4.751c0 .32.133.59.407.8.268.212.587.321.95.321.516 0 .975-.192 1.377-.576.401-.385.605-.833.605-1.352-.382-.3-.911-.454-1.593-.454-.497 0-.912.121-1.243.358-.338.25-.504.551-.504.903zM41.182 11.04l-4.08 9.428H35.84l1.517-3.299-2.69-6.128H36l1.938 4.7h.026l1.887-4.7h1.332z"
        ></path>
        <path
          fill="#4285F4"
          d="M18.535 12.936c0-.4-.035-.784-.102-1.153h-5.13v2.113l2.955.001a2.543 2.543 0 01-1.097 1.702v1.371h1.76c1.026-.954 1.614-2.366 1.614-4.034z"
        ></path>
        <path
          fill="#34A853"
          d="M15.162 15.6c-.49.331-1.12.525-1.857.525-1.425 0-2.634-.964-3.066-2.264H8.424v1.413a5.459 5.459 0 004.88 3.022c1.476 0 2.715-.487 3.617-1.326l-1.759-1.37z"
        ></path>
        <path
          fill="#FABB05"
          d="M10.068 12.812c0-.365.06-.718.17-1.05v-1.414H8.424a5.479 5.479 0 00-.58 2.463c0 .887.21 1.723.58 2.464l1.814-1.414a3.321 3.321 0 01-.17-1.05z"
        ></path>
        <path
          fill="#E94235"
          d="M13.305 9.497c.805 0 1.526.279 2.095.823l1.559-1.564c-.947-.886-2.181-1.43-3.654-1.43a5.46 5.46 0 00-4.88 3.022l1.813 1.414c.433-1.3 1.642-2.265 3.067-2.265z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5005_8689">
          <path
            fill="#fff"
            d="M0 0H48V25.617H0z"
            transform="translate(.5)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export const GooglePayLogoIllustration = memo(Illustration);
